module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('VAside', {
    attrs: {
      "sidebar-menus": _vm.sidebarMenus,
      "headerHeight": "50"
    }
  }, [_c('router-view', {
    staticStyle: {
      "margin": "20px"
    }
  })], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-74a62b4a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/alarm_manage/alarm_manage.vue
// module id = 1424
// module chunks = 1